
/* 验证输入的小数位数num位*/
export  function myRegExpS (str,num) {
  // var regExp = /^(0|[1-9]\d{0,9})(\.\d{0,2})?$/;
  var regExp = new RegExp("^(0|[1-9]\\d{0,9})(\\.\\d{0,"+num+"})?$");
  return regExp.test(str);
}

